<div class="container">
  <mic-breadcrumb id="casing-credit-details-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casingCredit"
      label="{{ translationService.translate('casingCreditText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingCreditDetailsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="casing-credit-details-header">
    <h2 class="page-title casing-credit-details-heading" id="casing-credit-heading">
      {{ translationService.translate('casingCreditDetailsText') }}
    </h2>
  </div>
  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isCreateInProgress">
    <div class="casing-credit-summary" id="customer-name">
      <div class="casing-credit-summary-text">
        <span class="casing-credit-label">{{ translationService.translate('codeText') }}: </span>
        <span class="casing-credit-value">{{ code }} | </span>
        <span class="casing-credit-label">{{ translationService.translate('descriptionText') }}: </span>
        <span class="casing-credit-value">{{ description }}</span>
      </div>
      <div class="action-bar">
        <button id="cancel" mat-flat-button class="btn-cancel casing-credit-details-action-button" (click)="cancel()">
          <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
        </button>
        <button
          id="save"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary casing-credit-details-action-button"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
        <button mat-flat-button color="primary" class="btn-export casing-credit-details-action-button" (click)="openExportModal()">
          <mat-icon>download</mat-icon>
          {{ translationService.translate('exportButtonText') }}
        </button>
      </div>
    </div>

    <mat-card class="casing-credit-details-filter-card">
      <form [formGroup]="filterForm" class="casing-credit-details-form">
        <div class="grid-container">
          <app-dropdown-search-single-select
            id="size"
            label="{{ translationService.translate('sizeText') }}"
            emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('sizeText') }}"
            placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('sizeText') }}"
            [formGroup]="filterForm"
            formControlName="size"
            [data]="sizeList"
          >
          </app-dropdown-search-single-select>
          <app-dropdown-search-single-select
            id="description"
            label="{{ translationService.translate('descriptionText') }}"
            emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
            placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
            [formGroup]="filterForm"
            formControlName="description"
            [data]="descriptionList"
          >
          </app-dropdown-search-single-select>
          <app-dropdown-search-single-select
            id="baseCredit"
            label="{{ translationService.translate('baseCreditText') }}"
            emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('baseCreditText') }}"
            placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('baseCreditText') }}"
            [formGroup]="filterForm"
            formControlName="baseCredit"
            [data]="baseCreditList"
          >
          </app-dropdown-search-single-select>
          <app-dropdown-search-single-select
            id="repairGrid"
            label="{{ translationService.translate('repairGridText') }}"
            emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('repairGridText') }}"
            placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('repairGridText') }}"
            [formGroup]="filterForm"
            formControlName="repairGrid"
            [data]="repairGridList"
          >
          </app-dropdown-search-single-select>
        </div>
        <div class="button-container">
          <button
            id="clear-filters"
            type="button"
            mat-flat-button
            color="accent"
            class="btn-clear clear-filters-button"
            (click)="clearFilters()"
          >
            <mat-icon>refresh</mat-icon> {{ translationService.translate('clearFiltersText') }}
          </button>
        </div>
      </form>
    </mat-card>

    <div id="casing-credit-details-table" class="cam-table table-container btn-table">
      <div class="table-wrapper">
        <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
          <ng-container *micTableNoData>
            <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
          </ng-container>
          <ng-container *micTableColumnSelector>
            <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
              <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
            </button>
            <mat-menu #colMenu="matMenu">
              <div class="column-menu-content">
                @for (key of columnKeys; track key) {
                <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">{{
                  columnNames[key] || key
                }}</mat-checkbox>
                }
              </div>
            </mat-menu>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'repairGridDropdown'">
            <mic-dropdown-search
              micDropdownAccessibility
              emptyPlaceholder="No data found"
              subscriptSizing="dynamic"
              [widthConfig]="{ width: '100%' }"
              [virtualScroll]="true"
              [data]="repairGridList"
              [formControl]="getControl(item, 'repairGrid')"
            ></mic-dropdown-search>
          </ng-container>
          <ng-container *micCellTemplate="let item; name: 'baseCredit'">
            <input
              id="BaseCreditInput"
              matInput
              type="text"
              min="0"
              step="0.01"
              pattern="^\\d+(\\.\\d{1,2})?$"
              maxlength="6"
              [attr.aria-label]="translationService.translate('baseCreditText')"
              [formControl]="getControl(item, 'baseCredit')"
              (keydown)="handleKeydown($event)"
              (input)="restrictTwoDecimalPlaces($event, item)"
            />
          </ng-container>
        </mic-table>
      </div>
    </div>
  </mic-spinner-overlay>
</div>
